import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSkullCrossbones,
  faTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    position: 'absolute',
    top: -46,
    left: 41,
    background: '#202020',
    padding: 13,
    borderRadius: 18,
    display: 'flex',
    flexDirection: 'column',
    gap: '13px'
  },
  button: {
    padding: '11px 23px',
    border: '3px solid #0000004f',
    borderRadius: 10,
    color: 'white',
    fontFamily: 'Clash Display',
    fontWeight: 600,
    fontSize: 15,
    display: 'flex',
    gap: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    textWrap: 'nowrap',
    cursor: 'pointer'
  },
  searchButton: {
    extend: 'button',
    background: '#B39426',
    '&:hover': {
      background: '#d0aa21'
    }
  },
  threatButton: {
    extend: 'button',
    background: '#8A3529',
    '&:hover': {
      background: '#ab4132'
    }
  },
  backgroundHider: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}));

type Props = {
  onSelect?: (isSearch: boolean) => void;
  onExit?: () => void;
};

function IdentPopup({ onSelect, onExit }: Props) {
  const classes = useStyles();
  return (
    <>
      <div className={classes.backgroundHider} onClick={onExit} />
      <div className={classes.container}>
        <div
          className={classes.searchButton}
          onClick={() => {
            onSelect && onSelect(true);
          }}
        >
          <FontAwesomeIcon icon={faTriangleExclamation} />
          Search / Too Dense
        </div>
        <div
          className={classes.threatButton}
          onClick={() => {
            onSelect && onSelect(false);
          }}
        >
          <FontAwesomeIcon icon={faSkullCrossbones} /> Threat
        </div>
      </div>
    </>
  );
}

export default IdentPopup;
